import React from 'react'
import { connect } from 'react-redux'
import { t } from 'ttag'
import { actions as formActions } from 'react-redux-form'
import debounce from 'lodash/debounce'

import ActionButton from '../../../components/ActionButton'
import { receivedResponse } from '../../../h2Api'
import Form from '../../../components/form/Form.js'
import Field from '../../../components/form/Field.js'
import {
  addAssociatedRecord,
  createProfileFromIntakeForm,
  doCallback,
  removeAssociatedRecord
} from '../../../actions/profileIntakeActions'
import * as v from '../../../components/form/validations'
import { browserHistory } from '../../../Routes'
import { scrollToTopOfScreen } from '../../../actions'

const model = 'localOpportunities.profileLoad.form'

class ProfileIntakeForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formDirty: false,
      errorMarkerShown: false
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    console.log(nextProps)

    return true
  }

  componentDidUpdate(nextProps, nextState, nextContext) {
    console.log(nextProps)

    if (this.state.formDirty && !this.state.errorMarkerShown) {
      const itms = document.querySelectorAll('.has-error')

      if (itms?.length > 0 ?? false) {
        const itmPos = [...itms].map(v => v.getBoundingClientRect().top)
        const topPos = Math.min(...itmPos)
        const offSet =
          Math.abs(document.body.getBoundingClientRect().top) - Math.abs(topPos)

        scrollToTopOfScreen()
        this.setState({ ...this.state, errorMarkerShown: true })
      }
    }
    //super.componentWillUpdate(nextProps, nextState, nextContext);
  }

  requiredAttributes = (f, s) => {
    const attrs = {}

    if (f.required) {
      attrs.validate = [v.required()]
      attrs.required = true
    }

    if (f.type === 'multiselect' || f.type == 'simpleselect') {
      const rslts = ((this.props.callbackResults[s.sectionKey] || {}).result || []).map(
        r => {
          return {
            label: r.label,
            value: {
              name: r.label,
              optionId: r.value
            }
          }
        }
      )

      attrs.options = rslts
      attrs.createFromValue = values => {
        return values.map(v => {
          return { label: v.name, value: v }
        })
      }
      attrs.onSearchChange = v => {
        if (v.length < 3) {
          return
        }

        debounce(
          this.props.dispatch(doCallback(f.callbackUrl, s.sectionKey, v)),
          200,
          true
        )
      }
    }

    return attrs
  }

  outputAdditionalMeta = (model, form) => {
    const metaData = this.props.additionalJson
    const reduxModel = this.props.form

    /*
     * const bbb = {}
     * console.log("TST", bbb.me?.you)
     */

    return (
      <div className="section">
        <h3>
          <span className="title">{t`More info about the company`}</span>
        </h3>
        {metaData && !metaData.doBypass && (
          <div>
            <div className="row">
              <p className="col-xs-12 text-center">
                <b>{t`Click a logo to select it, or enter the URL to your logo in the box below`}</b>
              </p>
            </div>
            <div
              className="row"
              style={{
                marginBottom: '25px',
                display: 'flex',
                flexWrap: 'wrap'
              }}>
              <div
                className={`profile-load-logo col-xs-6 ${
                  reduxModel.logoUrl === metaData.twitter.avatar ? 'selected' : ''
                }`}
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center'
                }}
                onClick={() => {
                  return this.props.dispatch(
                    formActions.change(`${model}.logoUrl`, metaData.twitter.avatar)
                  )
                }}>
                <a href>
                  <img
                    style={{ margin: 'auto' }}
                    src={metaData.twitter.avatar}
                    className="img-responsive"
                  />
                </a>
              </div>
              <div
                className={`profile-load-logo col-xs-6 ${
                  reduxModel.logoUrl === metaData.logo ? 'selected' : ''
                }`}
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center'
                }}
                onClick={() => {
                  return this.props.dispatch(
                    formActions.change(`${model}.logoUrl`, metaData.logo)
                  )
                }}>
                <a href>
                  <img
                    style={{ margin: 'auto' }}
                    src={metaData.logo}
                    className="img-responsive"
                  />
                </a>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-xs-12">
            <Field
              model={`${model}.logoUrl`}
              form={form}
              type="text"
              help="You can enter the URL of a logo you wish to use. You can usually right click on an image in your browser and select copy image address, which you can then paste into this box."
              label="Logo URL"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Field
              model={`${model}.twitter`}
              form={form}
              type="text"
              help={t`Enter the Twitter handle or the URL to the Twitter profile for your company`}
              label={t`Twitter Handle`}
            />
          </div>
          <div className="col-xs-12">
            <Field
              model={`${model}.facebook`}
              form={form}
              type="text"
              help={t`Enter the Facebook ID or the URL to the Facebook page for your company`}
              label={t`Facebook ID`}
            />
          </div>
          <div className="col-xs-12">
            <Field
              model={`${model}.linkedIn`}
              form={form}
              type="text"
              label={t`LinkedIn Company ID`}
              help={t`Enter the LinkedIn Company ID or the URL to the LinkedIn page for your company`}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { dispatch } = this.props

    console.log(this.props)
    const result = this.props.result
    const request = this.props.formRequest

    return [
      this.state.errorMarkerShown && (
        <div className="profile-intake-error" key="error-holder">
          {request.error ??
            t`An error was encountered while processing this form, please resolve the errors and try again.`}
        </div>
      ),
      <Form
        model={model}
        key="intake-form"
        onBeforeSubmit={s =>
          this.setState({ ...this.state, formDirty: true, errorMarkerShown: false })}
        onSubmit={p => {
          dispatch(createProfileFromIntakeForm(result.id, p)).then(v => {
            browserHistory.push('/profiles/intake/confirm')
          })
        }}>
        {form => (
          <div className="section" key="intake-form-sections">
            <h3>
              <span className="title">{t`Basic Information`}</span>
            </h3>
            <div className="row">
              <div className="col-xs-12">
                <Field
                  model={`${model}.title`}
                  form={form}
                  required={true}
                  type="text"
                  label="Company Name"
                />
              </div>
              <div className="col-xs-12">
                <Field
                  model={`${model}.url`}
                  form={form}
                  type="text"
                  label="Company URL"
                />
              </div>
            </div>
            {this.outputAdditionalMeta(model, form)}
            {result?.sections.map((s, idx) => (
              <div key={s.key}>
                {idx > 0 && <hr />}
                <h3>
                  <span className="title">{s.defaultTitle}</span>
                </h3>
                <div className="row">
                  {s.instructions && <p className={f.cssClass}>{s.instructions}</p>}
                  {s.fields.map(f => (
                    <div className={f.cssClass} key={`${s.key}-${f.key}`}>
                      <Field
                        model={`${model}.${s.sectionKey}-${f.key}`}
                        form={form}
                        type={f.type}
                        label={f.label || f.key}
                        {...this.requiredAttributes(f, s)}
                      />
                    </div>
                  ))}
                </div>
                {s.associatedRecordFields && (
                  <div>
                    {form[`${s.sectionKey}-associatedRecordFields`] &&
                      form[`${s.sectionKey}-associatedRecordFields`].map((ar, idx) => (
                        <div key={`${s.sectionKey}-associatedRecordFields-${idx}`}>
                          <div
                            className="col-xs-12"
                            style={{
                              borderBottom: '1px dashed #eee',
                              paddingTop: '15px',
                              backgroundColor: idx % 2 === 0 ? '#eee' : '#fff'
                            }}>
                            <div className="col-xs-10">
                              {s.associatedRecordFields.map((rec, i) => (
                                <div
                                  className={rec.cssClass}
                                  key={`${s.sectionKey}-associatedRecordFields-${idx}-${i}`}>
                                  <Field
                                    model={`${model}.${s.sectionKey}-associatedRecordFields[${idx}][${rec.key}]`}
                                    form={form}
                                    type={rec.type}
                                    label={rec.label || rec.key}
                                    {...this.requiredAttributes(rec)}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="col-xs-2">
                              <button
                                className="btn btn-default small"
                                type="button"
                                onClick={e => {
                                  e.preventDefault()
                                  dispatch(
                                    removeAssociatedRecord(model, s.sectionKey, idx)
                                  )
                                }}>
                                <i className="remove"></i> Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}

                    <div className="row text-center">
                      <div>
                        <button
                          style={{ marginTop: '25px' }}
                          type="button"
                          onClick={e => {
                            e.preventDefault()
                            dispatch(
                              addAssociatedRecord(
                                model,
                                s.sectionKey,
                                s.associatedRecordFields
                              )
                            )
                          }}
                          className="btn btn-default small">
                          <i className="add"></i> {t`Add Another Row`}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}

            <h3>
              <span className="title">{t`Notes`}</span>
            </h3>
            <div className="row">
              <div className="col-xs-12">
                <Field
                  model={`${model}.notes`}
                  form={form}
                  type="textarea"
                  label="Additional information"
                />
              </div>
            </div>
            <div className="nav" style={{ marginTop: '25px' }}>
              <ActionButton
                className="btn btn-success"
                loading={request.loading}
                error={request.error}
                success={receivedResponse(request) && t`Created`}>
                {t`Submit Application`}
              </ActionButton>
            </div>
          </div>
        )}
      </Form>
    ]
  }
}

export default connect(
  state => {
    return {
      additionalJson: state.localOpportunities.profileLoad.data.additionalJson,
      callbackResults: state.localOpportunities.profileLoad.data.callbackResults,
      result: state.localOpportunities.profileLoad.data.result,
      formRequest: state.localOpportunities.profileLoad.formRequest
    }
  },
  dispatch => ({
    dispatch
  })
)(ProfileIntakeForm)
